import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    settingsFormSection: {
        marginBottom: 25,
        '&:last-child': {
            marginBottom: 0
        },
        '& .MuiFormControl-root:nth-child(2)': {
            '& .MuiChip-root': {
                '& .MuiChip-icon': {
                    height: '18px',
                    width: '18px',
                }
            }
        },
        '& .MuiChip-deleteIcon': {
            height: '18px',
            width: '18px'
        },
        '& .MuiAutocomplete-clearIndicator': {
            '& .MuiSvgIcon-root': {
                height: '18px',
                width: '18px'
            }
        }
    },
    formSectionContent: {
        marginTop: 20
    },
    formSectionHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            flexDirection: 'column'
        }
    },
    formSectionHeading: {
        fontWeight: 500
    },
    formSectionCheckbox: {
        color: '#4A4A4A',
        display: 'flex',
        flexDirection: 'row',
        '& .MuiSvgIcon-root': {
            // fill: theme.palette.primary.main,
            // fontSize: '2.6rem'
            padding: 0,
            marginRight: '0px'
        },
        '& .MuiFormControlLabel-root': {
            margin: '0 10px 0 0',
            padding: 0,
            alignItems: 'flex-start',
            '& .MuiCheckbox-root': {
                padding: '0'
            }
        },
        '& ul': {
            paddingLeft: 0,
        },
        '& li': {
            listStyle: 'none',
            marginBottom: 8,
            '&:last-child': {
                marginBottom: 0
            }
        }
    },
    manualInput: {
        width: '100%',
        marginBottom: 25,
        '&:last-child': {
            marginBottom: 0
        }
    }
});